import React from 'react';

const initialsCircleStyle = (size, color) => {
  return {
    border: '1px solid rgba(0, 0, 0, 0.65)',
    borderRadius: '50%',
    borderColor: color,
    minWidth: `${size}px`,
    maxWidth: `${size}px`,
    minHeight: `${size}px`,
    maxHeight: `${size}px`,
    textAlign: 'center',
    display: 'inline-block',
  };
};

const initialsStyle = (size, color, modifierFromTop) => {
  return {
    position: 'relative',
    top: `${size * modifierFromTop}px`,
    fontSize: `${size * 0.45}px`,
    lineHeight: `${size * 0.5}px`,
    fontWeight: '700',
    color,
  };
};

const InitialsAvatar = ({
  name,
  size = '35',
  color = 'initial',
  modifierFromTop = 0.24,
}) => {
  if (!name) return null;
  const splitNames = name.split(' ');
  let initials = '';
  initials += splitNames[0][0];
  if (splitNames.length > 1) {
    initials +=
      splitNames[splitNames.length - 1] === ''
        ? ' '
        : splitNames[splitNames.length - 1][0];
  }
  return (
    <span style={initialsCircleStyle(size, color)}>
      <span style={initialsStyle(size, color, modifierFromTop)}>
        {initials.toUpperCase()}
      </span>
    </span>
  );
};

export default InitialsAvatar;
